import page from '../../components/page'
import search from '../../components/search'
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {api,imgPath} from '../../common/config.js'
import {store} from '../../store/store.js'

export default {
  name: 'rankList',
  data() {
    return {
      pageNo: 1,
      totalPage: 1,
      pageCount: 20,
      timeRank: 1,//时间排行榜：1月榜 2季榜 3年榜
      typeRank: 1,//功能排行榜 1点赞 2推荐 3借阅 4阅读
      imgError: store.imgError,
      webType: store.webType,
      rankingList: [],
      hallCode: "",
      sortType: 1,
      libCodeParams: "",
      imgPath:imgPath
    }
  },
  components: {
    page,
    search
  },
  watch: {
    $route() {
      this.querylist();
    }
  },
  mounted() {
    store.wrap.activeRouteName = '排行榜';
  },
  beforeMount() {
    this.querylist();
  },
  methods: {
    querylist() {
      this.hallCode = this.$route.query.hallCode || '';
      this.pageNo = this.$route.query.page || 1;
      this.sortType = this.$route.query.sortType || 1;//1:月榜 2:季榜 3:年榜，
      var rankingClass = this.$route.query.rankingClass || 1; //1点赞排行榜,2推荐排行榜,3借阅排行榜,4阅读排行榜
      this.typeRank = rankingClass;
      this.timeRank = this.sortType;
      if (store.webType == 1) {
        this.libCodeParams = "&libCode=" + this.hallCode;
      }
      if (rankingClass == 2) {
        this.recommendRanking();
      } else if (rankingClass == 3) {
        this.borrowRanking();
      } else if (rankingClass == 4) {
        this.ebookRanking();
      } else {
        this.praiseRanking();
      }
    },
    //阅读排行榜
    ebookRanking() {
      var url = api.ranking.ebookRanking.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
        .replace('{sortType}', this.sortType) + this.libCodeParams;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.rankingList = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },
    //点赞排行榜
    praiseRanking() {
      var url = api.ranking.praiseRanking.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
        .replace('{sortType}', this.sortType) + this.libCodeParams;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.rankingList = data.resultList;
        this.totalPage = data.totalPage;
      }, null, this);
    },
    //推荐排行榜
    recommendRanking() {
      var url = api.ranking.recommendRanking.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
        .replace('{sortType}', this.sortType) + this.libCodeParams;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.rankingList = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },
    //借阅排行榜
    borrowRanking() {
      var url = api.ranking.borrowRanking.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
        .replace('{sortType}', this.sortType) + this.libCodeParams;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.rankingList = data.resultList;
        this.totalPage = data.totalPage;
      }, null, this);
    },
    /**
     *
     * 其它跳转操作
     *
     */
    Ranking(num) {
      CommonUtil.mergeQuery(this, {rankingClass: num, page: 1});
    },
    //排行榜类型切换
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this, {page: pageNo});
    },
    //月榜切换
    sortClass: function (sortType) {
      CommonUtil.mergeQuery(this, {sortType: sortType, page: 1});
    },
    //图书详情页
    toBookInfo(isbn, id) {
      if (this.$route.query.rankingClass != 4) {
        this.$router.push({path: '/bookcontent', query: {isbn: isbn, hallCode: this.hallCode}});
      } else {
        this.$router.push({path: '/ebookinfo', query: {id: id, hallCode: this.hallCode}});
      }
    }
  }
}
